import { gql } from "@apollo/client";

export default gql`
  mutation UpdateGovernmentSettings($governmentId: ObjectId!, $settings: GovernmentSettingsInput!) {
    updateGovernmentSettings(governmentId: $governmentId, settings: $settings) {
      _id
      groups {
        _id
        name
        logo
      }
      settings {
        projectSharingWithGroups {
          _id
          name
          logo
        }
      }
    }
  }
`;
